// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"52":"8ca8a87d","228":"f4593d1f","433":"73fe4944"}[chunkId] + ".chunk.js");